/* Atlas bundles collection (ported from ac-cat-v2 plp-bundles.js): sort, load more and the bundle size picker.
   Each bundle card carries <script type="application/json" data-plpb-json="{id}"> with its pieces (one per
   product option) and variants. Add to cart adds the variant matching the chosen sizes. */
(function () {
  if (window.__atlasPlpb) return;
  window.__atlasPlpb = true;

  const $ = (s, r) => (r || document).querySelector(s);
  let cur = null, sel = {}, root = null, opener = null;

  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function variantFor() {
    const chosen = cur.pieces.map((p, i) => sel[i]);
    return cur.variants.find((v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i]));
  }
  /* Sizes that still make an available bundle with the other pieces already chosen */
  function sizeAvailable(i, z) {
    return cur.variants.some((v) => v.available && v.options[i] === z && v.options.every((o, k) => k === i || !sel[k] || sel[k] === o));
  }

  function render() {
    const body = $('[data-bs-pieces]', root);
    body.textContent = '';
    cur.pieces.forEach((p, i) => {
      const row = el('div', 'plpb-bs__piece');
      const img = el('img', 'plpb-bs__pimg'); img.src = p.img; img.alt = p.name; img.width = 64; img.height = 80;
      const col = el('div', 'plpb-bs__pcol');
      const top = el('div', 'plpb-bs__prow');
      top.appendChild(el('span', 'plpb-bs__pname', p.name));
      top.appendChild(el('span', 'plpb-bs__pstat' + (sel[i] ? ' is-on' : ''), sel[i] ? 'Size ' + sel[i] : 'Select size'));
      const sizes = el('div', 'plpb-bs__sizes');
      p.sizes.forEach((z) => {
        const b = el('button', 'plpb-bs__size' + (sel[i] === z ? ' is-on' : ''), z);
        b.type = 'button';
        b.setAttribute('aria-pressed', sel[i] === z ? 'true' : 'false');
        if (!sizeAvailable(i, z)) { b.disabled = true; b.style.opacity = '0.35'; b.style.textDecoration = 'line-through'; }
        b.addEventListener('click', () => { sel[i] = z; render(); });
        sizes.appendChild(b);
      });
      col.appendChild(top); col.appendChild(sizes);
      row.appendChild(img); row.appendChild(col);
      body.appendChild(row);
    });

    const left = cur.pieces.filter((p, i) => !sel[i]).length;
    const variant = left === 0 ? variantFor() : null;
    const ready = !!(variant && variant.available);
    let label;
    if (left === 0) label = ready ? 'Add to cart' : 'Combination unavailable';
    else if (left === cur.pieces.length) label = 'Select your sizes';
    else label = 'Select ' + left + ' more ' + (left === 1 ? 'size' : 'sizes');
    const btn = $('[data-bs-add]', root);
    btn.classList.toggle('is-ready', ready);
    btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    $('[data-bs-add-label]', root).textContent = label;
  }

  function open(id, btn) {
    const node = document.querySelector('[data-plpb-json="' + id + '"]');
    if (!node) return;
    try { cur = JSON.parse(node.textContent); } catch (e) { return; }
    /* combinations the cart already refused as sold out this visit stay greyed out */
    const A = window.Atlas;
    if (A && A.soldOut) cur.variants.forEach((v) => { if (A.soldOut.has(v.id)) v.available = false; });
    /* the card's own section when it has a size picker, else the one in the header */
    root = btn.closest('[data-plpb]') || document.querySelector('[data-plpb].plpb--global') || document.querySelector('[data-plpb]');
    opener = btn;
    sel = {};
    cur.pieces.forEach((p, i) => { if (p.sizes.length === 1) sel[i] = p.sizes[0]; });
    $('[data-bs-img]', root).src = cur.img;
    $('[data-bs-name]', root).textContent = cur.name;
    $('[data-bs-price]', root).textContent = cur.price;
    $('[data-bs-was]', root).textContent = cur.was;
    $('[data-bs-add-was]', root).textContent = cur.was;
    $('[data-bs-add-price]', root).textContent = cur.price;
    $('[data-bs-add-save]', root).textContent = cur.save;
    render();
    const staleErr = $('[data-bs-err]', root);
    if (staleErr) staleErr.hidden = true;
    $('[data-plpb-bs]', root).hidden = false;
    $('[data-plpb-scrim]', root).hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const close = $('[data-bs-close]', root);
    if (close) close.focus();
  }
  document.addEventListener('atlas:soldout', (e) => {
    if (!cur) return;
    let hit = false;
    cur.variants.forEach((v) => { if (v.available && e.detail.ids.indexOf(v.id) > -1) { v.available = false; hit = true; } });
    if (hit) render();
  });
  function close() {
    if (!root || !cur) return;
    $('[data-plpb-bs]', root).hidden = true;
    $('[data-plpb-scrim]', root).hidden = true;
    document.documentElement.style.overflow = '';
    cur = null;
    if (opener) opener.focus();
  }
  function add(btn) {
    if (!cur || btn.getAttribute('aria-disabled') === 'true') return;
    const variant = variantFor();
    if (!variant || !variant.available) return;
    const errEl = $('[data-bs-err]', root);
    if (errEl) errEl.hidden = true;
    btn.setAttribute('aria-disabled', 'true');
    window.Atlas.cart.add([{ id: variant.id, quantity: 1 }], { open: true })
      .then(() => close())
      .catch((err) => {
        if (window.console) console.error('Add to cart failed', err);
        if (errEl) {
          errEl.textContent = (err && err.description) || 'Sorry, this couldn\'t be added to your cart. Please try again.';
          errEl.hidden = false;
        }
        /* repaint: a refused combination is now greyed out and the button says so */
        if (cur) render(); else btn.setAttribute('aria-disabled', 'false');
      });
  }

  /* Load more: fetch the next page and append its cards */
  function loadMore(link) {
    const r = link.closest('[data-plpb]');
    link.classList.add('is-loading');
    fetch(link.href)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = $('[data-plpb-grid]', doc);
        if (grid) Array.from(grid.children).forEach((c) => $('[data-plpb-grid]', r).appendChild(c));
        const foot = $('[data-plpb-foot]', doc);
        const mine = $('[data-plpb-foot]', r);
        if (foot && mine) mine.replaceWith(foot);
        else if (mine) mine.remove();
      })
      .catch(() => { window.location.href = link.href; });
  }

  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-plpb-open]');
    if (o) { open(o.dataset.plpbOpen, o); return; }
    if (e.target.closest('[data-bs-close]') || e.target.closest('[data-plpb-scrim]')) { close(); return; }
    const a = e.target.closest('[data-bs-add]');
    if (a) { add(a); return; }
    const m = e.target.closest('[data-plpb-more]');
    if (m) { e.preventDefault(); loadMore(m); }
  });
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-plpb-sort]');
    if (!s) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();
